import { Modifier } from './Modifier';
export class DisplacementModifier extends Modifier {
    constructor(disabled, parameters, noise3D) {
        super('displacement', disabled, parameters, false);
        this.noise3D = noise3D;
    }
    apply(geometry) {
        if (this.disabled)
            return;
        const positions = geometry.attributes.position.array;
        const { noiseScale, translation, strength } = this.parameters;
        for (let i = 0; i < positions.length; i += 3) {
            const x = positions[i];
            const y = positions[i + 1];
            const z = positions[i + 2];
            // Calculate radius for radial displacement
            const radius = Math.sqrt(x * x + z * z);
            // Generate 3D noise value using the noiseScale parameter and translation
            const noise = this.noise3D((x * noiseScale) + translation, (y * noiseScale) + translation, (z * noiseScale) + translation);
            // Calculate displacement magnitude (noise value from -1 to 1)
            let displacement = noise * strength;
            // Clamp displacement to ±20% of the original radius
            const maxDisp = radius * 0.2;
            if (displacement > maxDisp) {
                // console.warn(`[DisplacementModifier] Displacement (${displacement}) > 20% of radius (${maxDisp}) at vertex ${i/3}`);
                displacement = maxDisp;
            }
            else if (displacement < -maxDisp) {
                // console.warn(`[DisplacementModifier] Displacement (${displacement}) < -20% of radius (${maxDisp}) at vertex ${i/3}`);
                displacement = -maxDisp;
            }
            // Apply displacement radially (only in XZ plane)
            if (radius > 0 && isFinite(displacement) && !isNaN(displacement)) {
                positions[i] += (x / radius) * displacement;
                positions[i + 2] += (z / radius) * displacement;
            }
        }
        geometry.attributes.position.needsUpdate = true;
        geometry.computeVertexNormals();
    }
}
